import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import { Row } from "reactstrap";
import Modal from "../../Components/Common/Modal";

import Loading from "../../Components/Loading/Loading";
import { deleteServiceRequest } from "../../store/services/actions";

function ServiceTable({ services, loading }) {
  const [modal, setModal] = useState(false);
  const [idServiceSelected, setIdServiceSelected] = useState(null);
  const dispatch = useDispatch();

  if (loading) {
    return <Loading />;
  }

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      selector: (row) => row.nome || "N/A",
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Telefone</span>,
      selector: (row) => row.telefone || "N/A",
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Whatsapp</span>,
      selector: (row) => row.whatsapp || "N/A",
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Cidade</span>,
      selector: (row) => row.cidade?.nome || "N/A",
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Ações</span>,
      right: true,
      selector: (row) => (
        <div className="hstack gap-3 flex-wrap">
          <Link
            to={`/services-form/${row.objectId}`}
            className="link-success fs-15"
          >
            <i className="ri-edit-2-line"></i>
          </Link>
          <Link
            to="#"
            className="link-danger fs-15"
            onClick={() => {
              setIdServiceSelected(row.objectId);
              setModal(true);
            }}
          >
            <i className="ri-delete-bin-line"></i>
          </Link>
        </div>
      ),
    },
  ];

  function deleteService() {
    dispatch(
      deleteServiceRequest({
        serviceId: idServiceSelected,
        closeModal: () => {
          setIdServiceSelected(null);
          setModal(false);
        },
      })
    );
  }

  return (
    <React.Fragment>
      <Row>
        <ToastContainer />
        <DataTable
          columns={columns}
          data={services}
          pagination
          noDataComponent="Não existem dados na tabela de serviços!"
        />
      </Row>
      <Modal
        loading={loading}
        size="md"
        text="Tem certeza que deseja excluir esse serviço?"
        isOpen={modal}
        onClick={deleteService}
        onCancel={() => {
          setModal(false);
          setIdServiceSelected(null);
        }}
      />
    </React.Fragment>
  );
}

export { ServiceTable };
